/**
 * reCAPTCHA v3 utility functions
 *
 * Provides helpers for integrating Google reCAPTCHA v3 with form submissions
 */

/* global grecaptcha */

/**
 * Get reCAPTCHA token for form submission
 * @param {string} action - The action name for this reCAPTCHA request (e.g., 'submit_form', 'schedule_consultation')
 * @returns {Promise<string>} The reCAPTCHA token
 */
export function getRecaptchaToken(action) {
  if (!action) {
    action = 'submit_form';
  }

  return new Promise(function (resolve, reject) {
    try {
      grecaptcha.ready(function () {
        // Get the site key from WordPress localized script
        var siteKey = window.sanctum && window.sanctum.recaptcha_site_key;

        if (!siteKey) {
          console.error('reCAPTCHA site key not found in sanctum object');
          reject(new Error('reCAPTCHA not configured'));
          return;
        }

        // Execute reCAPTCHA and get token
        grecaptcha
          .execute(siteKey, { action: action })
          .then(function (token) {
            resolve(token);
          })
          .catch(function (error) {
            console.error('Error executing reCAPTCHA:', error);
            reject(error);
          });
      });
    } catch (error) {
      console.error('Error getting reCAPTCHA token:', error);
      reject(error);
    }
  });
}

/**
 * Verify reCAPTCHA token with WordPress REST API
 * @param {string} token - The reCAPTCHA token to verify
 * @returns {Promise<Object>} The verification response with success status and score
 */
export function verifyRecaptchaToken(token) {
  return fetch('/wp-json/sanctum/v1/verify-recaptcha', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token: token }),
  })
    .then(function (response) {
      return response.json();
    })
    .catch(function (error) {
      console.error('Error verifying reCAPTCHA token:', error);
      throw error;
    });
}

export default {
  getRecaptchaToken: getRecaptchaToken,
  verifyRecaptchaToken: verifyRecaptchaToken,
};



// WEBPACK FOOTER //
// ./scripts/util/recaptcha.js